import { socketHost } from '@/utils/hostsconfig'
import { initSocketMsgData,getUserLocalData } from '@/utils/auth'
import { getChannelInfo } from "@/api/base"

let connectTimer

const relogin = () => {
  location.reload()
}

const sendSocketMsg = data => {
  let msg = initSocketMsgData(data)
  // console.log("GET_QUESTION")
  $_chat.sendKeepalive(msg)
}

const connectSocket = userInfo => {
  let socketConnInfo = {
    host: socketHost,
    port: '80'
  }
  if (window.location.protocol === 'https:') {
    socketConnInfo.port = '443'
  }
  const connMsg = {
    'event': 'LOGIN',
    'role': 'STUDENT',
    'account_id': userInfo.account_id,
    'learning_version': 3,
    'user_id': userInfo.user_id,//学生ID
    'subject_id': userInfo.subject_id,//学科ID
    'school_id': userInfo.school_id,//学校ID 后端没有，使用默认值0
    'course_id': userInfo.course_id,//课程ID
    'course_name': userInfo.course_name,
    'lesson_id': userInfo.lesson_id || '',//课次ID 后端没有
    'lesson_name': userInfo.lesson_name || '',
    'stage': userInfo.stage,
    'topic_id': userInfo.chapter_id,//专题ID
    'topic_name': userInfo.chapter_name,
    'client_ip': userInfo.clientIp,//客户端IP
    'app_type': userInfo.app_type,//可以依据学校ID来区分线上或是线下(1: 线上   2:线下）
    'nick': userInfo.user_name,//昵称
    'question_bank_version': 'V5'
  }

  const { chapter_type } = getUserLocalData();
  // let chapter_type = 99; // 99 教师培训 不走监课
  if(chapter_type != 99){
    window.Monitor.init(socketConnInfo.host, socketConnInfo.port, connMsg)
  }
}
export default connectSocket


// WEBPACK FOOTER //
// ./src/connectSocket.js